import { render, staticRenderFns } from "./CardPaymentMethod.vue?vue&type=template&id=bb89f4ca&scoped=true&"
import script from "./CardPaymentMethod.vue?vue&type=script&lang=js&"
export * from "./CardPaymentMethod.vue?vue&type=script&lang=js&"
import style0 from "./CardPaymentMethod.vue?vue&type=style&index=0&id=bb89f4ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb89f4ca",
  null
  
)

export default component.exports